import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { instance } from "api/apiBase";
import { PaginatedResponse } from "shared/types";
import { getErrorMessage } from "utils/error";

const WAITLIST_LEADS_KEY = "WAITLIST_LEADS";

export interface WaitlistLead {
  id: number;
  first_name: string | null;
  last_name: string | null;
  primary_email: string | null;
  primary_phone: string | null;
  from_waitlist_at: string | null;
  created_at: string;
  source?: { id: number; name: string | null } | null;
}

export const useWaitlistLeads = (unitId?: number) => {
  const [page, setPage] = useState(1);

  const { data, isFetching } = useQuery({
    queryKey: [WAITLIST_LEADS_KEY, unitId, page],
    queryFn: () =>
      instance
        .get<PaginatedResponse<WaitlistLead>>("/portal/v1/leads", {
          params: {
            unit_ids: [unitId],
            from_waitlist: true,
            order_by: "created_at",
            order_direction: "desc",
            page,
            per_page: 20
          }
        })
        .then((res) => res.data),
    enabled: Boolean(unitId),
    placeholderData: keepPreviousData,
    meta: { onError: (error: unknown) => toast.error(getErrorMessage(error)) }
  });

  return {
    leads: data?.items ?? [],
    pageCount: data?.page_count ?? 0,
    page,
    setPage,
    isFetching
  };
};
